import "./Commitment.scss";
import CommitmentInfo from "./components/CommitmentInfo/CommitmentInfo";
import OurValues from "./components/OurValues/OurValues";
import TrashInfo from "./components/TrashInfo/TrashInfo";

const Commitment = () => {
  return (
    <div className="commitment">
      <CommitmentInfo />
      <OurValues />
      <TrashInfo />
    </div>
  );
};

export default Commitment;
